<template>
    <div>
        <form v-if="doctor">
            <div class="field has-text-centered">
                <a href="#" @click.prevent="toggleAvatarSelector(true)">
                    <avatar :avatar="doctor.avatar" :name="doctor.firstName + ' ' + doctor.lastName" class="is-inline image is-96x96"></avatar>
                </a>
                <span class="is-size-7 has-text-grey is-block">{{ $t('click_to_change_avatar') }}</span>
            </div>
            <div class="columns">
                <div class="column">
                    <div class="field">
                        <label class="label" v-text="$t('first_name_label')"></label>
                        <p class="control has-icon has-icons-right">
                            <input
                                v-validate="'required'"
                                :class="{'input': true, 'is-danger': errors.has('doctor.firstName') }"
                                v-model="doctor.firstName"
                                name="doctor.firstName"
                                type="text">
                            <span v-show="errors.has('doctor.firstName')" class="icon is-right is-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                        </p>
                    </div>
                </div>
                <div class="column">
                    <div class="field">
                        <label class="label" v-text="$t('last_name_label')"></label>
                        <p class="control has-icon has-icons-right">
                            <input
                                v-validate="'required'"
                                :class="{'input': true, 'is-danger': errors.has('doctor.lastName') }"
                                v-model="doctor.lastName"
                                name="doctor.lastName"
                                type="text">
                            <span v-show="errors.has('doctor.lastName')" class="icon is-right is-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="field">
                <label class="label" v-text="$t('contact_email_label')"></label>
                <p class="control has-icon has-icons-right">
                    <input
                        v-validate="'required|email'"
                        :class="{'input': true, 'is-danger': errors.has('doctor.contactEmail') }"
                        v-model="doctor.contactEmail"
                        name="doctor.contactEmail"
                        type="text">
                </p>
            </div>
            <div class="field">
                <label class="label" v-text="$t('medical_practice_label')"></label>
                <div class="control has-icon has-icons-right">
                    <div class="select is-fullwidth">
                        <select :value="doctor.type" disabled>
                            <option v-for="type in medicalPractices" :value="type">{{ $t('type_' + type) }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="field">
                <label class="label" v-text="$t('inami_label')"></label>
                <p class="control has-icon has-icons-right">
                    <input
                        class="input disabled"
                        :value="doctor.inami"
                        type="text"
                        disabled
                        autocomplete="off">
                </p>
            </div>
            <div class="field">
                <label class="checkbox">
                    <input
                        type="checkbox"
                        v-model="doctor.isRegulated">
                        <span v-html="$t('is_regulated_label')"></span>
                </label>
            </div>
            <div class="field" :class="Object.keys(countries).length == 1 ? 'is-hidden' : ''">
                <label class="label" v-text="$t('DoctorProfile.country_label')"></label>
                <div class="control has-icon has-icons-right">
                    <div class="select">
                        <select v-model="doctor.countryId">
                            <option v-for="country in countries" :value="country.id" v-text="$t(`Countries_${countr.code}`)"></option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="field">
                <label class="label" v-text="$t('language_label')"></label>
                <div class="control has-icon has-icons-right">
                    <div class="select">
                        <select v-model="doctor.language">
                            <option v-for="(language, id) in languages" :value="language.code">{{ language.name }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <button class="button is-primary has-icon" @click.prevent="saveDetails">
                <b-icon icon="check-circle"></b-icon>
                <span>{{ $t('update_button_label') }}</span>
            </button>
        </form>
        <b-modal :active.sync="showAvatarSelector">
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ $t('avatar_title') }}</p>
                </header>
                <section class="modal-card-body has-text-centered">
                    <div v-for="(avatarPath, avatar) in avatars" class="is-inline-block mx-2 my-2" :class="avatar == doctor.avatar ? 'selected-avatar' : 'unselected-avatar'">
                        <a href="#" @click.prevent="selectAvatar(avatar)">
                            <avatar :avatar="avatar" :name="avatarPath" class="image is-96x96"></avatar>
                        </a>
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <button class="button" type="button" @click="toggleAvatarSelector(false)">{{ $t('cancel_button_label') }}</button>
                </footer>
            </div>
        </b-modal>
    </div>
</template>

<script>
import helpers from '@/mixins/helpers'
import firebase from 'firebase/app'
import { store } from '@/store'

import doctorRepository from '@/data/DoctorRepository'

export default {
    name: 'profile-details',

    mixins: [helpers],

    data () {
        return {
            avatars: process.env.AVATARS,
            medicalPractices: [
                'DENTIST',
                'GENERAL_PRACTITIONER',
                'GYNECOLOGIST',
                'OPHTHALMOLOGIST',
                'PEDIATRICIAN',
                'PSYCHOLOGIST',
                'DERMATOLOGIST',
                'OSTEOPATH',
                'PSYCHIATRIST',
                'PHYSIOTHERAPIST',
            ],
            showAvatarSelector: false
        }
    },

    mounted () {
        if (! this.doctor.hasOwnProperty('countryId')) {
            var country = _.find(this.countries, {code: 'be'})

            this.doctor.countryId = country.id
        }
    },

    methods: {
        saveDetails () {
            this.setLoading(true)

            this.$validator.validateAll().then((result) => {
                if (! result) {
                    this.alertError(this.$t('fields_are_missing'))
                    this.setLoading(false)

                    return false
                }

                this.doctor.lastName = this.doctor.lastName.trim()
                this.doctor.lastName = this.doctor.lastName.charAt(0).toUpperCase() + this.doctor.lastName.slice(1)
                this.doctor.firstName = this.doctor.firstName.trim()
                this.doctor.firstName = this.doctor.firstName.charAt(0).toUpperCase() + this.doctor.firstName.slice(1)

                // Only pass fields that can be updated
                var data = {
                    avatar: this.doctor.avatar,
                    lastName: this.doctor.lastName,
                    firstName: this.doctor.firstName,
                    contactEmail: this.doctor.contactEmail,
                    type: this.doctor.type,
                    isRegulated: this.doctor.isRegulated,
                    language: this.doctor.language,
                    countryId: this.doctor.countryId,
                }

                doctorRepository.update(this.doctor.id, data, () => {
                    this.alertSuccess(this.$t('alert_update_successful'))

                    this.setLocale(this.doctor.language)

                    this.setLoading(false)
                }, (error) => {
                    this.alertError(error.message)

                    this.setLoading(false)
                })
            })
        },

        toggleAvatarSelector (show) {
            this.showAvatarSelector = show
        },

        selectAvatar (avatar) {
            this.doctor.avatar = avatar
            this.toggleAvatarSelector(false)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Doctor/ProfileDetails.vue